/**
 * sessionStorage access that never throws (private mode / blocked storage): reads give null and
 * writes are skipped, so callers can treat the stored value as best effort.
 */

/**
 * @param {string} key
 * @returns {string|null}
 */
export function getSessionItem(key) {
    try {
        return sessionStorage.getItem(key);
    } catch {
        return null;
    }
}

/**
 * @param {string} key
 * @param {string|null} value - null removes the item.
 */
export function setSessionItem(key, value) {
    try {
        if (value === null) {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, value);
        }
    } catch {
        // storage unavailable: nothing to persist
    }
}
